<template>
  <div></div>
</template>

<script>
  import Vue from 'vue'
  Vue.prototype.$apiURL = 'https://back.ses.kr.ua'
  //Vue.prototype.$apiURL = 'https://cors-anywhere.herokuapp.com/https://back.ses.kr.ua'

   export default {
    name : 'AppProperty',
   }

</script>